import { render, staticRenderFns } from "./SourcePageMobile.vue?vue&type=template&id=642f91e7&scoped=true&"
import script from "./SourcePageMobile.vue?vue&type=script&lang=js&"
export * from "./SourcePageMobile.vue?vue&type=script&lang=js&"
import style0 from "./SourcePageMobile.vue?vue&type=style&index=0&id=642f91e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f91e7",
  null
  
)

export default component.exports